import React from "react";
import { useTranslation } from "react-i18next";
import { academicYear, programs, formatTimeRange } from "../../data/programs";

// Circles programme for adults (girls / women / men). Every schedule value comes
// from src/data/programs — this component only renders it.
const ProgramIntro = () => {
  const { t } = useTranslation("home");

  return (
    <section className="programme-section section-padding" id="programme">
      <div className="container">
        <div className="section-title">
          <h2>{t("programme.title")}</h2>
          <h3>
            {t("programme.year", {
              hijriYear: academicYear.hijriYear,
              gregorianYear: academicYear.gregorianYear,
            })}
          </h3>
        </div>

        <div className="row g-4 justify-content-center">
          {programs.map((program) => (
            <div className="col-lg-4 col-md-6 col-12" key={program.id}>
              <div className="programme-card">
                <h4 className="programme-card__title">
                  {t(`programme.categories.${program.category}.title`)}
                </h4>

                {program.instructor && (
                  <p className="programme-card__instructor">
                    <span>{t("programme.supervisor")}:</span>{" "}
                    {t(`programme.instructors.${program.instructor}`)}
                  </p>
                )}

                {program.levelKeys.length > 0 && (
                  <div className="programme-card__levels">
                    {program.levelKeys.map((levelKey) => (
                      <span className="programme-badge" key={levelKey}>
                        {t(`programme.levels.${levelKey}`)}
                      </span>
                    ))}
                  </div>
                )}

                <ul className="programme-card__sessions">
                  {program.sessions.map((session, index) => (
                    <li key={`${program.id}-${session.day}-${index}`}>
                      <span className="programme-card__day">
                        {t(`days.${session.day}`)}
                      </span>
                      <span className="programme-card__time" dir="ltr">
                        {formatTimeRange(session)}
                      </span>
                    </li>
                  ))}
                </ul>

                {program.methodKey && (
                  <div className="programme-card__method">
                    <h5>{t(`programme.method.${program.methodKey}.title`)}</h5>
                    <p>{t(`programme.method.${program.methodKey}.body`)}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramIntro;
